import React, { Component } from 'react';
import { Grid, Row, Col } from 'react-bootstrap';
import { Link } from 'react-router-dom';
import './ConsumerExperience.css';
import QuoteCarousel from './QuoteCarousel';
import glenVideo from '../../res/glenarc-small.mp4';


class ConsumerExperience extends Component {
  constructor(props) {
    super(props);
    this.state = {
      quotes: [
        {
          author: 'Liam Brogan, Ireland Craft Beers',
          content: 'More than ever, consumers want to know where their food and drink comes from. Consumers want transparency, they want authenticity and they want to trust in the brands they purchase.',
        },
      ],
    };
  }


  render() {
    return (
      <div className="consumer-experience">
        <Grid>
          <Row className="wrapper">
            <Col xs={12} md={6} className="col-one">
              <Row>
                <Col md={1} xs={0} />
                <Col md={11} xs={12}>
                  <div className="storybook">
                    <h1>Consumer Experience <br />
                      - your unique storybook
                    </h1>
                    <h3>
                      Deliver direct consumer interaction regarding taste, heritage,
                      sustainability via customisable high quality user experience.
                    </h3>
                    <p className="storybook-link">
                      <Link to="/contact" className="link curious"> Curious? Help us create your unique storybook →  </Link>
                    </p>
                  </div>
                </Col>
              </Row>
              <Row className="quote-carousel">
                <Col md={1} xs={0} />
                <Col md={11} xs={12}>
                  <QuoteCarousel quotes={this.state.quotes} />
                </Col>
              </Row>
            </Col>
            <Col xs={12} md={6} className="col-two">
              <div className="player-container image-placeholder">
                <video
                  className="overlay-video"
                  src={glenVideo}
                  ref={videoRef => {
                    this.videoRef = videoRef;
                  }}
                  style={{
                    position: 'absolute',
                    bottom: 0,
                    left: '8%',
                    width: '84%',
                    height: '85%',
                  }}
                  autoPlay
                  playsInline
                  muted
                  loop
                />
              </div>
            </Col>
          </Row>
        </Grid>
      </div>
    );
  }
}

export default ConsumerExperience;




// WEBPACK FOOTER //
// ./src/components/common/ConsumerExperience.js